// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file.

console.log(
	'%c This site was designed & developed by https://www.sleeplessmedia.com',
	'background:#000; color: #ae956e; padding: 10px 15px; font-size: 13px; font-weight: 500; width: 100%;'
);

// Cookies functions
function setCookie(cookieName, cookieValue) {
	var today = new Date();
	var expire = new Date();
	expire.setTime(today.getTime() + 3600000 * 24 * 7);
	document.cookie =
		cookieName +
		'=' +
		encodeURI(cookieValue) +
		';expires=' +
		expire.toGMTString();
}

function getCookie(cname) {
	let name = cname + '=';
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}
